<template>
  <div class="content cert-info-manage">
    <div class="title-box">
      <span>认证资料管理</span>
    </div>

    <div v-if="certDetailError || !formOwner || formOwnerInvalidated" class="cert-state-banner warn">
      <span>{{ !formOwner || formOwnerInvalidated ? '当前人员或企业信息不可用，请重新进入认证页面' : submissionOutcomeUnknown ? '提交结果暂未确认，请重试或稍后重新进入页面' : '认证状态查询失败，请重试' }}</span>
      <el-button v-if="formOwner && !formOwnerInvalidated" size="mini" @click="refreshCertificationStatus">重试</el-button>
    </div>

    <el-form ref="ruleForm" :model="form" :disabled="isReadonly" label-width="150px" class="mb-4">
      <!-- start of 选择身份 -->
      <div class="base">
        <div class="title" @click="isExpandIdentity = !isExpandIdentity">
          <div class="title-config">
            <i :class="isExpandIdentity ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            选择身份
          </div>
        </div>
        <div v-show="isExpandIdentity" class="form-item-box">
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>身份</span>
                </span>
                <div class="identity-cards">
                  <div
                    v-for="item in identityOptions"
                    :key="item.value"
                    :class="['identity-card', form.identity === item.value ? 'active' : '', isReadonly ? 'disabled' : '']"
                    @click="changeIdentity(item.value)"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 选择身份 -->

      <!-- start of 基本信息 -->
      <div class="base">
        <div class="title" @click="isExpandBase = !isExpandBase">
          <div class="title-config">
            <i :class="isExpandBase ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            基本信息
          </div>
        </div>
        <div v-show="isExpandBase" class="form-item-box">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="name">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>姓名</span>
                </span>
                <el-input v-model="form.name" maxlength="20" placeholder="请输入" @input="onIdentityChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="mobileNo">
                <span slot="label">
                  <span>手机号及邮箱</span>
                </span>
                <div class="inline-group">
                  <el-input v-model="form.mobileNo" disabled placeholder="开通账号的手机号"></el-input>
                  <el-input v-model="form.email" maxlength="128" placeholder="请输入邮箱"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idCode">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>身份证号</span>
                </span>
                <el-input v-model="form.idCode" maxlength="18" placeholder="请输入" @input="onIdentityChanged" @blur="checkIdCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="orgName">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>{{ isStudent ? '所在院校' : '所在机构' }}</span>
                </span>
                <el-input v-model="form.orgName" maxlength="256" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="deptGuid">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>{{ isStudent ? '所在专业' : '所在科室' }}</span>
                </span>
                <el-cascader
                  v-model="deptPath"
                  :options="deptTree"
                  :props="deptProps"
                  :show-all-levels="false"
                  clearable
                  placeholder="请选择"
                  @change="onDeptChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="needTitle">
              <el-form-item prop="titleGuid">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>职称</span>
                </span>
                <el-select v-model="form.titleGuid" placeholder="请选择" @change="onTitleChange">
                  <el-option
                    v-for="item in titleOptions"
                    :key="item.guid"
                    :label="item.dicName"
                    :value="item.guid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="position">
                <span slot="label">
                  <span>职务</span>
                </span>
                <el-input v-model="form.position" maxlength="128" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="workStartYear">
                <span slot="label">
                  <span>工作起始年份</span>
                </span>
                <el-date-picker
                  v-model="form.workStartYear"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="exp-col">
              <el-form-item prop="labelExperience">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>标注经验</span>
                </span>
                <el-input
                  v-model="form.labelExperience"
                  type="textarea"
                  :rows="4"
                  maxlength="2000"
                  show-word-limit
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 基本信息 -->

      <!-- start of 学历信息 -->
      <div class="base">
        <div class="title" @click="isExpandEdu = !isExpandEdu">
          <div class="title-config">
            <i :class="isExpandEdu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            学历信息
          </div>
        </div>
        <div v-show="isExpandEdu" class="form-item-box">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="eduStart">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>起止时间</span>
                </span>
                <div class="inline-group">
                  <el-date-picker
                    v-model="form.eduStart"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="开始年月"
                    class="w146"
                  ></el-date-picker>
                  <el-date-picker
                    v-model="form.eduEnd"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="结束年月"
                    class="w146"
                  ></el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="graduatedFrom">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>毕业院校</span>
                </span>
                <el-input v-model="form.graduatedFrom" maxlength="256" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="professional">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>专业及学历</span>
                </span>
                <div class="inline-group">
                  <el-input v-model="form.professional" maxlength="128" placeholder="请输入专业" class="w146"></el-input>
                  <el-select v-model="form.education" placeholder="学历" class="w146">
                    <el-option
                      v-for="item in getCodeListByKey('学历')"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 学历信息 -->

      <!-- start of 资质信息 -->
      <div class="base">
        <div class="title" @click="isExpandQual = !isExpandQual">
          <div class="title-config">
            <i :class="isExpandQual ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
            资质信息（任选其一即可）
          </div>
        </div>
        <div v-show="isExpandQual" class="form-item-box">
          <div class="qual-cards">
            <div v-for="qual in form.qualificationList" :key="qual.qualType" class="qual-card">
              <div class="qual-head">
                <span class="qual-name">{{ qual.qualType }}：</span>
              </div>
              <!-- 已上传：卡片+悬浮操作（参考 Element picture-card 自定义模板）；未上传：+ 号触发器，点击直传 obs -->
              <div v-if="qual.attachPath" class="qual-file-card">
                <img :src="qual.attachPath" class="qual-file-img" alt="" />
                <span class="qual-file-actions">
                  <span class="qual-action" @click="previewQual(qual)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!isReadonly" class="qual-action" @click="removeQualAttach(qual)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <el-upload
                v-else
                action="#"
                list-type="picture-card"
                class="qual-uploader"
                :http-request="(content) => uploadQualAttach(content, qual)"
                :show-file-list="false"
                accept=".jpg,.png,.jpeg"
                :disabled="isReadonly"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <!-- end of 资质信息 -->
    </el-form>

    <!-- start of 协议签署 -->
    <div class="base protocol-box">
      <div class="title" @click="isExpandProtocol = !isExpandProtocol">
        <div class="title-config">
          <i :class="isExpandProtocol ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          平台保密协议
        </div>
        <el-button type="primary" size="small" icon="el-icon-document" @click.stop="showProtocol">查看协议</el-button>
      </div>
      <div v-show="isExpandProtocol" class="protocol-body">
        <platform-protocol-sign
          ref="protocolSection"
          embedded
          :certification-ready="certDetailReady && !!formOwner && !formOwnerInvalidated && !submitting"
          :certification-error="certDetailError || !formOwner || formOwnerInvalidated"
          :certification-state="approveState"
          :certification-readonly="isReadonly"
          :protocol-signature="form.protocolSignature"
          :effective-cert-guid="effectiveCertGuid"
          :effective-protocol-signature="effectiveProtocolSignature"
          :identity-changed="identityChanged"
          @signature-change="onSignatureChange"
        />
      </div>
    </div>
    <!-- end of 协议签署 -->

    <!-- start of 流程审批 -->
    <div class="back-color-fff mt-4">
      <div class="flow">
        <approval-process v-if="processReady" :approveVO="processApproveVO" :flow-type="flowType" />
      </div>
    </div>
    <!-- end of 流程审批 -->

    <!-- 按钮区 -->
    <div class="back-color-fff submit_btn_wrap">
      <el-button size="small" v-if="canSave" @click="onSave" :loading="submitting">保存</el-button>
      <el-button size="small" type="primary" v-if="canChange" @click="onChange">变更</el-button>
      <el-button size="small" v-if="canCancelChange" :disabled="submitting" @click="onCancelChange">取消</el-button>
      <el-button size="small" type="primary" v-if="canSubmit" @click="onSubmit" :loading="submitting">
        {{ submitBtnText }}
      </el-button>
      <el-button size="small" v-if="canRevoke" @click="onRevoke" :loading="submitting">撤销</el-button>
    </div>

    <!-- 资质图片预览弹窗（白底，替代 el-image 黑色遮罩查看器） -->
    <el-dialog
      title="资质图片预览"
      :visible.sync="qualPreviewVisible"
      append-to-body
      width="620px"
    >
      <img v-if="qualPreviewUrl" :src="qualPreviewUrl" alt="资质图片" class="qual-preview-img" />
    </el-dialog>
  </div>
</template>

<script>
import idNumber from "@/assets/js/idNumber.js";
import { getPlatformDeptTenantGuid } from "@/uilt/platformDeptGuid";
import PlatformProtocolSign from "./platformProtocolSign.vue";

function currentDraftOwner() {
  try {
    const user = JSON.parse(localStorage.userInfo || "{}");
    let separateUserId = localStorage.userId || "";
    if (separateUserId[0] === '"') separateUserId = JSON.parse(separateUserId);
    if (user.userGuid && separateUserId && user.userGuid !== separateUserId) return null;
    const userGuid = user.userGuid || separateUserId;
    const staffGuid = user.staffGuid;
    const tenantGuid = localStorage.guid;
    if (!userGuid || !staffGuid || !tenantGuid) return null;
    return { userGuid, staffGuid, tenantGuid };
  } catch (e) {
    return null;
  }
}

function sameDraftOwner(left, right) {
  return !!left && !!right && left.userGuid === right.userGuid
    && left.staffGuid === right.staffGuid && left.tenantGuid === right.tenantGuid;
}

// 新后端返回 protocolSignature；兼容旧申请只存 protocolSignSnapshot 的读取路径。
function readCertSignature(detail) {
  if (!detail) return null;
  const direct = detail.protocolSignature;
  if (direct && typeof direct === "object" && direct.signed === true && direct.signAttach) return direct;
  if (detail.protocolSignSnapshot != null && detail.protocolSignSnapshot !== "") {
    try {
      const snapshot = JSON.parse(detail.protocolSignSnapshot);
      return snapshot && snapshot.signed === true && snapshot.signAttach ? snapshot : null;
    } catch (e) {
      return null;
    }
  }
  return null;
}

export default {
  name: "certInfoManage",
  components: {
    // 流程图渲染库体积大，随组件拆成独立 chunk，进页面后再拉取
    ApprovalProcess: () => import("@/components/ApprovalProcess/index"),
    PlatformProtocolSign,
  },
  data() {
    return {
      identityOptions: [],
      deptTree: [],
      deptProps: { value: "guid", label: "deptName", children: "childList" },
      deptPath: [],
      titleTree: [],
      submitting: false,
      formOwner: null,
      formOwnerInvalidated: false,
      certDetailRequestId: 0,
      certDetailReady: false,
      certDetailError: false,
      certDetailLoaded: false,
      submissionOutcomeUnknown: false,
      // 审批流程区块：详情返回后才渲染；approveVO 仅在含完整 camunda 信息时传入
      processReady: false,
      processApproveVO: null,
      // 人员认证审核流程编码
      flowType: "00103",
      // 审批状态：'' 无记录 / N 初始 / A 审批中 / Y 通过 / R 驳回 / C 撤销
      approveState: "",
      latestApproveState: "",
      // 已通过(Y)的变更编辑态：默认只读，点"变更"进入编辑，提交后回审批中
      editMode: false,
      // 本申请已保存签署（详情回填，用于展示/提交）
      savedProtocolSignature: null,
      // 最新有效 Y 的签署，用于变更默认沿用
      effectiveProtocolSignature: null,
      effectiveCertGuid: "",
      // my-detail 标记：当前主行为草稿 / 变更草稿
      certDraft: false,
      changeDraft: false,
      // 载入时的身份基线：姓名/身份证变化必须重签
      baselineIdentity: null,
      identityChanged: false,
      // 资质图片预览弹窗
      qualPreviewVisible: false,
      qualPreviewUrl: "",
      // 区块折叠状态（questionnaireAdd 同款可折叠卡片框架）
      isExpandIdentity: true,
      isExpandBase: true,
      isExpandEdu: true,
      isExpandQual: true,
      isExpandProtocol: true,
      form: {
        guid: "",
        identity: "",
        name: "",
        mobileNo: "",
        email: "",
        idCode: "",
        orgName: "",
        deptGuid: "",
        deptName: "",
        titleGuid: "",
        titleName: "",
        position: "",
        workStartYear: "",
        labelExperience: "",
        eduStart: "",
        eduEnd: "",
        graduatedFrom: "",
        professional: "",
        education: "",
        qualificationList: [],
        // 平台保密协议签署随表单保存：新签 {signAttach,protocolGuid,protocolVersion,contentDigest}；沿用 {reuseFromCertGuid}
        protocolSignature: null,
      },
    };
  },
  computed: {
    // 医学生
    isStudent() {
      return this.form.identity === "5";
    },
    // 医生/护士/药师/技师 需要职称
    needTitle() {
      return ["1", "2", "3", "4"].includes(this.form.identity);
    },
    // 首次(''/N)及首审驳回/撤销(R/C)直接可编辑；已通过(Y)默认只读，点"变更"进入编辑态；审批中(A)锁定
    // （口径收敛 2026-09-09：变更=仅首次提交且审批通过后，与后端 isChange 分流一致——R/C 从未通过，重提走 00103 首审不算变更）
    isReadonly() {
      if (!this.certDetailReady) return true;
      if (this.approveState === "A") return true;
      if (this.approveState === "Y") return !this.editMode;
      return false;
    },
    // 任意可编辑状态均可保存草稿（''/N/R/C，以及已通过后的变更编辑态）
    canSave() {
      if (!this.certDetailReady) return false;
      if (this.approveState === "Y") return this.editMode;
      return ["", "N", "R", "C"].includes(this.approveState);
    },
    // 已通过(Y)须进入变更编辑态才显示提交按钮；''/N/R/C 直接显示；审批中(A)隐藏（FOUR-2977：提交后按钮须隐藏，撤销入口仍在）
    canSubmit() {
      if (!this.certDetailReady) return false;
      if (this.approveState === "A") return false;
      if (this.approveState === "Y") return this.editMode;
      return true;
    },
    // 已通过(Y)且未进入编辑态：显示"变更"入口按钮（首审驳回/撤销不走变更，直接重新编辑提交）
    canChange() {
      return this.certDetailReady && this.approveState === "Y" && !this.editMode;
    },
    // 变更编辑态或变更草稿的退出按钮
    canCancelChange() {
      return this.certDetailReady && ((this.approveState === "Y" && this.editMode) || this.changeDraft);
    },
    canRevoke() {
      return this.certDetailReady && this.approveState === "A";
    },
    // 变更/Y 编辑/变更草稿为"提交"；首次及首审驳回/撤销重提为"提交审核"
    submitBtnText() {
      return this.approveState === "Y" || this.changeDraft ? "提交" : "提交审核";
    },
    // 表单签署是否可随保存/提交上报（新签或沿用）
    signatureSubmittable() {
      const signature = this.form.protocolSignature;
      if (!signature) return false;
      if (signature.reuseFromCertGuid) return true;
      return !!(signature.signAttach && signature.protocolGuid
        && signature.protocolVersion && signature.contentDigest);
    },
    // 旧快照只展示、不能沿用；提交前须重新签署
    signatureLegacy() {
      const signature = this.form.protocolSignature;
      return !!(signature && signature.signAttach && !this.signatureSubmittable);
    },
    // 职称选项：按身份取对应序列（字典树"职称"下的分组）
    titleOptions() {
      const groupName = { "1": "医生职称", "2": "护士职称", "3": "药师职称", "4": "技师职称" }[
        this.form.identity
      ];
      if (!groupName) return [];
      const group = (this.titleTree || []).find((item) => item.dicName === groupName);
      return group && group.childList ? group.childList : [];
    },
  },
  created() {
    this.formOwner = currentDraftOwner();
    this.initDict();
    this.getDeptTree();
    this.getTitleTree();
    this.getMyDetail();
  },
  // keep-alive 恢复时刷新认证状态（签署已并入表单，不再单独查询）。
  activated() {
    this.refreshOnFocus();
  },
  mounted() {
    window.addEventListener("focus", this.refreshOnFocus);
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.refreshOnFocus);
  },
  methods: {
    showProtocol() {
      if (this.$refs.protocolSection) this.$refs.protocolSection.openProtocol();
    },
    initDict() {
      this.identityOptions = this.getCodeListByKey("认证身份");
      if (!this.identityOptions.length) {
        // 兜底：字典未配置时按约定值展示
        this.identityOptions = [
          { value: "1", text: "医生" },
          { value: "2", text: "护士" },
          { value: "3", text: "药师" },
          { value: "4", text: "技师" },
          { value: "5", text: "医学生" },
          { value: "6", text: "其他" },
        ];
      }
      // 手机号/姓名/邮箱/身份证号回显账号人员信息，新增时避免二次填写（草稿数据由 my-detail 回来后按非空覆盖）
      try {
        let userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        this.form.mobileNo = userInfo.mobileNo || "";
        this.form.name = userInfo.staffName || "";
        this.form.email = userInfo.email || "";
        this.form.idCode = userInfo.idCode || "";
      } catch (e) {
        console.log(e);
      }
      // 首次进入的身份基线：之后改姓名/身份证需重新签名（详情返回后以详情为准）
      this.baselineIdentity = { name: this.form.name || "", idCode: this.form.idCode || "" };
    },
    // 科室树（统一口径：平台租户的 mf_med_dept 树——医院科室是一套按租户维护的配置表业务
    // （科室管理页），非字典；与小程序 getPlatformGuid 同款环境分支。存量 deptGuid 本就是
    // mf_med_dept 体系的 guid，编辑回显不受影响）
    getDeptTree() {
      this.api
        .get(`/${serverConfig.msPersonnelService}/staff-cert/dept-tree?tenantGuid=${getPlatformDeptTenantGuid()}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.deptTree = res.data.data || [];
            this.rebuildDeptPath();
          }
        });
    },
    // 编辑回显：按 deptGuid 反推级联路径
    rebuildDeptPath() {
      if (!this.form.deptGuid || !this.deptTree.length) return;
      const findPath = (nodes, target, trail) => {
        for (const node of nodes || []) {
          const next = [...trail, node.guid];
          if (node.guid === target) return next;
          const hit = findPath(node.childList, target, next);
          if (hit) return hit;
        }
        return null;
      };
      const path = findPath(this.deptTree, this.form.deptGuid, []);
      if (path) this.deptPath = path;
    },
    // 职称树（按身份分序列）
    getTitleTree() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=职称`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.titleTree = res.data.data || [];
          }
        });
    },
    changeIdentity(value) {
      if (this.isReadonly) return;
      this.form.identity = value;
      this.form.titleGuid = "";
      this.form.titleName = "";
      this.buildQualList();
    },
    qualificationTypeName(type) {
      return { "医师执业证书": "执业证书", "医师资格证": "资格证书" }[type] || type;
    },
    // 资质卡片按身份动态：医学生=学生证；其他身份=执业证书/资格证书/工作证胸牌
    buildQualList() {
      const types = this.isStudent
        ? ["学生证"]
        : ["执业证书", "资格证书", "工作证/胸牌"];
      const old = this.form.qualificationList || [];
      this.form.qualificationList = types.map((t) => {
        const exist = old.find((item) => this.qualificationTypeName(item.qualType) === t) || {};
        return {
          qualType: t,
          expiryDate: exist.expiryDate || "",
          attach: exist.attach || "",
          attachPath: exist.attachPath || "",
        };
      });
    },
    onDeptChange(value) {
      const path = value || [];
      this.form.deptGuid = path.length ? path[path.length - 1] : "";
      let deptName = "";
      let nodes = this.deptTree;
      for (const guid of path) {
        const node = (nodes || []).find((item) => item.guid === guid);
        if (!node) break;
        // FOUR-3007：科室树已切平台租户 dept-tree（MedDeptTreeVO 字段为 deptName），
        // 此处曾残留字典时代的 dicName 读法导致 deptName 恒空串落库（列表/详情科室为空的根因）
        deptName = node.deptName;
        nodes = node.childList;
      }
      this.form.deptName = deptName;
    },
    onTitleChange(guid) {
      const hit = this.titleOptions.find((item) => item.guid === guid);
      this.form.titleName = hit ? hit.dicName : "";
    },
    // 审批流程区块：有 camunda 实例展示实例图；无实例（免审/撤销/初始填写态）时
    // 组件按 flowType 反查部署 ID 展示流程定义图（反查在组件内完成，页面不再单独请求）
    showApprovalProcess(approveVO) {
      this.processApproveVO =
        approveVO && approveVO.camundaInstanceId && approveVO.camundaDeploymentId ? approveVO : null;
      this.processReady = true;
    },
    uploadQualAttach(content, qual) {
      let isLt5M = content.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
        return;
      }
      // 后缀白名单（accept 可被绕过）
      const name = (content.file.name || "").toLowerCase();
      if (!/\.(jpg|jpeg|png)$/.test(name)) {
        this.$message.error("仅支持 jpg/png/jpeg 格式图片");
        return;
      }
      let formData = new FormData();
      formData.append("file", content.file);
      formData.append("fileName", content.file.name);
      this.api
        .postImage(
          `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
          formData
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            qual.attach = JSON.stringify({
              fileName: content.file.name,
              path: res.data.data.data,
            });
            qual.attachPath = res.data.data.data;
            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        });
    },
    previewQual(qual) {
      this.qualPreviewUrl = qual.attachPath;
      this.qualPreviewVisible = true;
    },
    removeQualAttach(qual) {
      qual.attach = "";
      qual.attachPath = "";
    },
    // 资质列表提交前处理：剔除整行空白
    buildQualParams() {
      return (this.form.qualificationList || [])
        .filter((item) => item.attach)
        .map((item) => ({
          qualType: item.qualType,
          expiryDate: "9999-12-31",
          attach: item.attach,
        }));
    },
    buildParams() {
      return {
        guid: this.form.guid || "",
        // 网关 X-USERINFO 不含租户字段，后端依赖前端显式传当前公司
        tenantGuid: localStorage.guid || "",
        identity: this.form.identity,
        name: this.form.name,
        mobileNo: this.form.mobileNo,
        email: this.form.email,
        idCode: this.form.idCode,
        orgName: this.form.orgName,
        deptGuid: this.form.deptGuid,
        deptName: this.form.deptName,
        titleGuid: this.form.titleGuid,
        titleName: this.form.titleName,
        position: this.form.position,
        workStartYear: this.form.workStartYear,
        labelExperience: this.form.labelExperience,
        eduStart: this.form.eduStart,
        eduEnd: this.form.eduEnd,
        graduatedFrom: this.form.graduatedFrom,
        professional: this.form.professional,
        education: this.form.education,
        qualificationList: this.buildQualParams(),
        protocolSignature: this.buildProtocolSignature(),
      };
    },
    // 表单签署按契约只上报新签/沿用字段；旧快照仅展示，不再作为可提交签署
    buildProtocolSignature() {
      const signature = this.form.protocolSignature;
      if (!signature) return null;
      if (signature.reuseFromCertGuid) return { reuseFromCertGuid: signature.reuseFromCertGuid };
      if (signature.signAttach && signature.protocolGuid
          && signature.protocolVersion && signature.contentDigest) {
        return {
          signAttach: signature.signAttach,
          protocolGuid: signature.protocolGuid,
          protocolVersion: signature.protocolVersion,
          contentDigest: signature.contentDigest,
        };
      }
      return null;
    },
    // 身份证格式校验（公共工具 idNumber.cnid，managementPersonnel 同款）
    checkIdCode() {
      if (this.form.idCode && idNumber.cnid(this.form.idCode) === false) {
        this.$message.error("身份证信息错误");
      }
    },
    checkForm() {
      if (!this.form.identity) return "请选择身份";
      if (!this.form.name) return "请填写姓名";
      if (!this.form.idCode) return "请填写身份证号";
      if (idNumber.cnid(this.form.idCode) === false) return "身份证信息错误";
      if (this.form.mobileNo && !/^1[3-9]\d{9}$/.test(this.form.mobileNo)) return "手机号格式不正确";
      if (this.form.email && !/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(this.form.email)) return "邮箱格式不正确";
      if (!this.form.orgName) return this.isStudent ? "请填写所在院校" : "请填写所在机构";
      if (!this.form.deptGuid) return this.isStudent ? "请选择所在专业" : "请选择所在科室";
      if (this.needTitle && !this.form.titleGuid) return "请选择职称";
      if (!this.form.labelExperience) return "请填写标注经验";
      if (this.form.labelExperience.length > 2000) return "标注经验不超过2000个字";
      if (!this.form.eduStart || !this.form.eduEnd) return "请选择学历起止时间";
      if (!this.form.graduatedFrom) return "请填写毕业院校";
      if (!this.form.professional) return "请填写专业";
      if (!this.form.education) return "请选择学历";
      if (!this.buildQualParams().length) return "资质信息至少填写一项";
      return "";
    },
    ensureSignatureSettled() {
      const section = this.$refs.protocolSection;
      if (section && (section.submitting || section.editingSignature)) {
        this.$message.error("请先确认或取消修改签名");
        return false;
      }
      if (section && section.hasDrawn) {
        this.$message.error("请先确认签署或清除签名");
        return false;
      }
      return true;
    },
    // 子组件确认签名后回填表单，保存/提交时统一上报
    onSignatureChange(signature) {
      if (this.submitting) return;
      if (signature && !signature.reuseFromCertGuid
          && (!signature.signAttach || !signature.protocolGuid
            || !signature.protocolVersion || !signature.contentDigest)) {
        this.$message.error("签名信息不完整，请重新签署");
        return;
      }
      this.form.protocolSignature = signature;
    },
    // schema2 签名才能作为新签/沿用上报；legacy 只做展示
    toSubmittableSignature(signature) {
      if (!signature || signature.signed !== true || signature.legacy === true || !signature.signAttach) return null;
      if (signature.schema != null && Number(signature.schema) < 2) return null;
      if (!signature.protocolGuid || !signature.protocolVersion || !signature.protocolContentDigest) return null;
      return {
        signAttach: signature.signAttach,
        protocolGuid: signature.protocolGuid,
        protocolVersion: signature.protocolVersion,
        contentDigest: signature.protocolContentDigest,
        signTime: signature.signTime,
      };
    },
    toLegacyDisplaySignature(signature) {
      if (!signature || signature.signed !== true || !signature.signAttach) return null;
      return { ...signature, legacy: true };
    },
    // 变更沿用：必须有有效 Y 的 schema2 快照
    reusableEffectiveSignature() {
      return !!(this.effectiveCertGuid && this.toSubmittableSignature(this.effectiveProtocolSignature));
    },
    // 进入变更/载入变更草稿的默认签署：身份未变优先沿用有效 Y
    defaultChangeSignature() {
      if (this.reusableEffectiveSignature()) return { reuseFromCertGuid: this.effectiveCertGuid };
      if (this.approveState === "Y" && this.form.guid
          && this.toSubmittableSignature(this.savedProtocolSignature)) {
        return { reuseFromCertGuid: this.form.guid };
      }
      return this.toSubmittableSignature(this.savedProtocolSignature);
    },
    identityMatchesBaseline() {
      if (!this.baselineIdentity) return true;
      return (this.form.name || "") === (this.baselineIdentity.name || "")
        && (this.form.idCode || "") === (this.baselineIdentity.idCode || "");
    },
    // 姓名/身份证变化后旧签名（含沿用）失效；改回基线时恢复默认签署
    onIdentityChanged() {
      if (this.isReadonly) return;
      if (!this.identityMatchesBaseline()) {
        // 首次填写尚无签署时，改身份本身不需要提示重签；已有签署才失效
        if (this.form.protocolSignature || this.savedProtocolSignature) {
          this.identityChanged = true;
          this.form.protocolSignature = null;
        }
        return;
      }
      this.identityChanged = false;
      if (!this.form.protocolSignature) {
        this.form.protocolSignature = this.approveState === "Y" && this.editMode
          ? this.defaultChangeSignature()
          : this.resolveInitialSignature();
      }
    },
    // 详情恢复表单签署：schema2 作为可提交签署；legacy 仅展示
    resolveLoadedSignature() {
      const signature = this.savedProtocolSignature;
      const submittable = this.toSubmittableSignature(signature);
      if (submittable) return submittable;
      return this.toLegacyDisplaySignature(signature);
    },
    // 详情回填：本申请新签优先；变更草稿未重新签署时默认沿用有效 Y（保留实际签署时间）
    resolveInitialSignature() {
      const saved = this.savedProtocolSignature;
      const savedSubmittable = this.toSubmittableSignature(saved);
      const savedReused = !!(saved && typeof saved.source === "string"
        && saved.source.indexOf("REUSE_FROM:") === 0);
      if (this.changeDraft && this.reusableEffectiveSignature()
          && (!savedSubmittable || savedReused)) {
        return { reuseFromCertGuid: this.effectiveCertGuid };
      }
      return this.resolveLoadedSignature();
    },
    onSave() {
      if (this.submitting || !this.canSave || !this.ensureSignatureSettled()) return;
      if (!this.ensureFormOwner()) return;
      this.submitting = true;
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-cert/save`, this.buildParams())
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("保存成功");
            this.getMyDetail();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    // 进入变更编辑态（仅已通过状态可达）：身份未变默认沿用有效 Y 的签署
    onChange() {
      if (!this.canChange) return;
      this.editMode = true;
      this.identityChanged = false;
      this.form.protocolSignature = this.defaultChangeSignature();
    },
    // 退出变更/放弃变更草稿：有 N 草稿先调 discard-draft，再重新拉取详情
    async onCancelChange() {
      if (this.submitting || !this.canCancelChange) return;
      const section = this.$refs.protocolSection;
      if (section && section.submitting) {
        this.$message.error("签名处理中，请稍后重试");
        return;
      }
      const discardDraft = this.approveState === "N" && this.changeDraft;
      try {
        await this.$confirm(
          discardDraft
            ? "取消变更将放弃本次已保存的变更草稿，原有效认证保持不变，确定取消吗？"
            : "退出变更将丢弃已修改的内容，确定退出吗？",
          "提示",
          { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
        );
      } catch (e) {
        return;
      }
      if (this.submitting || !this.canCancelChange || (section && section.submitting)) return;
      if (!this.ensureFormOwner()) return;
      if (discardDraft) {
        this.submitting = true;
        try {
          const res = await this.api.postJson(
            `/${serverConfig.msPersonnelService}/staff-cert/discard-draft?tenantGuid=${encodeURIComponent(this.formOwner.tenantGuid)}`
          );
          if (!res || !res.data || res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.error((res && res.data && res.data.msg) || "放弃变更草稿失败，请稍后重试");
            return;
          }
        } catch (e) {
          this.$message.error("放弃变更草稿失败，请稍后重试");
          return;
        } finally {
          this.submitting = false;
        }
        if (!this.ensureFormOwner()) return;
      }
      if (section && section.editingSignature) section.cancelModifySignature();
      this.getMyDetail();
    },
    async onSubmit() {
      if (this.submitting || !this.canSubmit) return;
      if (!this.ensureSignatureSettled()) return;
      if (!this.ensureFormOwner()) return;
      const errMsg = this.checkForm();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      if (!this.signatureSubmittable) {
        this.$message.error(this.signatureLegacy
          ? "原协议签署为历史数据，请重新签署平台保密协议后再提交"
          : "请先签署平台保密协议，再提交认证审核");
        return;
      }
      this.submitting = true;
      try {
        let certRes;
        try {
          certRes = await this.api.get(
            `/${serverConfig.msPersonnelService}/staff-cert/my-detail?tenantGuid=${localStorage.guid || ''}`
          );
        } catch (e) {
          this.$message.error("认证状态查询失败，请稍后重试");
          return;
        }
        if (!this.ensureFormOwner()) return;
        const cert = certRes && certRes.data && certRes.data.data;
        if (!certRes || !certRes.data || certRes.data.code != serverConfig.REQUIRE_SUCCESS_CODE
            || cert === undefined || (cert !== null && (typeof cert !== "object" || Array.isArray(cert)
              || !["N", "A", "Y", "R", "C"].includes(cert.approveState)))) {
          this.$message.error("认证状态查询失败，请稍后重试");
          return;
        }
        const currentState = (cert && cert.approveState) || "";
        const currentLatestState = (cert && (cert.latestApproveState || cert.approveState)) || "";
        if (currentState === "A") {
          this.onCertStatusChanged({ approveState: currentState, latestApproveState: currentLatestState });
          this.$message.error("当前认证资料正在审批中，不可重复提交；填写内容已保留");
          return;
        }
        if (currentState !== this.approveState
            || (this.latestApproveState && currentLatestState !== this.latestApproveState)) {
          this.onCertStatusChanged({ approveState: currentState, latestApproveState: currentLatestState });
          this.$message.error("认证状态已发生变化，填写内容已保留，请检查当前资料");
          return;
        }
        // 已通过(Y)提交变更时保留确认弹窗；变更审批期间生效认证（最新通过行）不受影响，仍可正常接收任务。
        if (this.approveState === "Y") {
          try {
            await this.$confirm("提交后将进入变更审批，审批期间不影响接收新任务，确定提交变更吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            });
          } catch (e) {
            return;
          }
        }
        if (!this.ensureFormOwner()) return;
        await this.doSubmit();
      } finally {
        this.submitting = false;
      }
    },
    doSubmit() {
      const params = this.buildParams();
      return this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-cert/submit`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            this.approveState = "A";
            this.changeDraft = false;
            this.editMode = false;
            this.$message.success("提交成功");
            this.getMyDetail();
          } else {
            this.$message.error(res.data.msg || "提交失败");
          }
        })
        .catch(async () => {
          this.submissionOutcomeUnknown = true;
          this.certDetailReady = false;
          await this.reconcileSubmissionOutcome();
        });
    },
    // 响应丢失不能认定提交失败；my-detail/submit-outcome 返回 A 即视为提交成功。
    async reconcileSubmissionOutcome() {
      if (!this.ensureFormOwner()) return;
      const owner = this.formOwner;
      const requestId = ++this.certDetailRequestId;
      this.certDetailReady = false;
      this.certDetailError = false;
      try {
        const res = await this.api.get(
          `/${serverConfig.msPersonnelService}/staff-cert/submit-outcome?tenantGuid=${encodeURIComponent(owner.tenantGuid)}`
        );
        if (requestId !== this.certDetailRequestId) return;
        if (!sameDraftOwner(owner, currentDraftOwner())) {
          this.clearFormForOwnerChange();
          return;
        }
        const detail = res && res.data && res.data.data;
        if (!res || !res.data || res.data.code != serverConfig.REQUIRE_SUCCESS_CODE || !detail
            || detail.approveState !== "A" || detail.staffGuid !== owner.staffGuid) throw new Error();
        this.approveState = "A";
        this.latestApproveState = "A";
        this.changeDraft = false;
        this.editMode = false;
        this.submissionOutcomeUnknown = false;
        this.certDetailReady = true;
        this.$message.success("认证已提交");
        this.getMyDetail();
      } catch (error) {
        if (requestId === this.certDetailRequestId) {
          this.certDetailError = true;
          this.$message.warning("提交结果暂未确认，请稍后重试");
        }
      }
    },
    onRevoke() {
      this.$confirm("确定撤销当前审批中的认证吗？撤销后将恢复到提交前的状态。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.submitting = true;
        this.api
          .postJson(`/${serverConfig.msPersonnelService}/staff-cert/revoke?tenantGuid=${localStorage.guid || ''}`)
          .then((res) => {
            this.submitting = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("撤销成功");
              this.getMyDetail();
            } else {
              this.$message.error(res.data.msg || "撤销失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      });
    },
    getMyDetail() {
      const requestId = ++this.certDetailRequestId;
      this.certDetailReady = false;
      this.certDetailError = false;
      return this.api
        .get(`/${serverConfig.msPersonnelService}/staff-cert/my-detail?tenantGuid=${localStorage.guid || ''}`)
        .then((res) => {
          if (requestId !== this.certDetailRequestId) return;
          if (this.formOwner && !sameDraftOwner(this.formOwner, currentDraftOwner())) {
            this.clearFormForOwnerChange();
            return;
          }
          const detail = res && res.data && res.data.data;
          if (!res || !res.data || res.data.code != serverConfig.REQUIRE_SUCCESS_CODE || detail === undefined
              || (detail !== null && (typeof detail !== "object" || Array.isArray(detail)
                || !["N", "A", "Y", "R", "C"].includes(detail.approveState)
                || (detail.staffGuid && this.formOwner && detail.staffGuid !== this.formOwner.staffGuid)))) {
            this.certDetailError = true;
            this.$message.error("认证状态查询失败，请稍后重试");
            return;
          }
          this.certDetailReady = true;
          this.certDetailLoaded = true;
          const data = res.data.data || null;
          this.latestApproveState = (data && (data.latestApproveState || data.approveState)) || "";
          const currentState = (data && data.approveState) || "";
          this.approveState = currentState;
          this.editMode = false;
          this.certDraft = !!(data && data.draft);
          this.changeDraft = !!(data && data.changeDraft);
          this.effectiveCertGuid = (data && data.effectiveCertGuid) || "";
          this.effectiveProtocolSignature =
            data && data.effectiveProtocolSignature && typeof data.effectiveProtocolSignature === "object"
              ? data.effectiveProtocolSignature
              : null;
          this.savedProtocolSignature = readCertSignature(data);
          if (data) {
            Object.keys(this.form).forEach((key) => {
              if (key !== "qualificationList" && key !== "protocolSignature"
                  && data[key] !== undefined && data[key] !== null) {
                this.form[key] = data[key];
              }
            });
            // 资质回显
            this.buildQualList();
            (data.qualificationList || []).forEach((item) => {
              const target = this.form.qualificationList.find(
                (q) => q.qualType === this.qualificationTypeName(item.qualType)
              );
              if (target) {
                target.expiryDate = item.expiryDate
                  ? String(item.expiryDate).substring(0, 10)
                  : "";
                target.attach = item.attach || "";
                try {
                  target.attachPath = item.attach ? JSON.parse(item.attach).path : "";
                } catch (e) {
                  target.attachPath = "";
                }
              }
            });
            // 科室级联回显
            this.rebuildDeptPath();
            this.baselineIdentity = { name: this.form.name || "", idCode: this.form.idCode || "" };
            this.identityChanged = false;
            this.form.protocolSignature = this.resolveInitialSignature();
          } else {
            this.savedProtocolSignature = null;
            this.changeDraft = false;
            this.form.protocolSignature = null;
            this.identityChanged = false;
          }
          // 审批流程图：有 camunda 实例展示实例图，否则组件按流程编码兜底展示定义图
          // （初始态无认证记录 data=null 也走定义图，分支须在 if 外）
          this.showApprovalProcess((res.data.data && res.data.data.approveVO) || null);
        })
        .catch(() => {
          if (requestId === this.certDetailRequestId) {
            this.certDetailError = true;
            if (!sameDraftOwner(this.formOwner, currentDraftOwner())) {
              this.clearFormForOwnerChange();
              return;
            }
            this.$message.error("认证状态查询失败，请稍后重试");
          }
        });
    },
    onCertStatusChanged(status) {
      if (!this.ensureFormOwner()) return;
      this.approveState = status.approveState || "";
      this.latestApproveState = status.latestApproveState || "";
      this.editMode = false;
      if (this.approveState !== "N") this.changeDraft = false;
      this.certDetailReady = true;
      this.certDetailError = false;
    },
    async refreshCertificationStatus() {
      if (!this.ensureFormOwner()) return;
      if (this.submissionOutcomeUnknown) return this.reconcileSubmissionOutcome();
      if (!this.certDetailLoaded) {
        await this.getMyDetail();
        return;
      }
      const owner = this.formOwner;
      const requestId = ++this.certDetailRequestId;
      this.certDetailReady = false;
      this.certDetailError = false;
      try {
        const res = await this.api.get(
          `/${serverConfig.msPersonnelService}/staff-cert/my-detail?tenantGuid=${encodeURIComponent(owner.tenantGuid)}`
        );
        if (requestId !== this.certDetailRequestId) return;
        if (!sameDraftOwner(owner, currentDraftOwner())) {
          this.clearFormForOwnerChange();
          return;
        }
        const detail = res && res.data && res.data.data;
        if (!res || !res.data || res.data.code != serverConfig.REQUIRE_SUCCESS_CODE || detail === undefined
            || (detail !== null && (typeof detail !== "object" || Array.isArray(detail)
              || !["N", "A", "Y", "R", "C"].includes(detail.approveState)
              || (detail.staffGuid && detail.staffGuid !== owner.staffGuid)))) throw new Error();
        const approveState = (detail && detail.approveState) || "";
        const latestApproveState = (detail && (detail.latestApproveState || detail.approveState)) || "";
        const statusChanged = approveState !== this.approveState || latestApproveState !== this.latestApproveState;
        if (statusChanged) {
          this.editMode = false;
          if (approveState !== "N") this.changeDraft = false;
          this.$message.warning("认证状态已变化，填写内容已保留，请检查当前资料");
        }
        this.approveState = approveState;
        this.latestApproveState = latestApproveState;
        this.certDetailReady = true;
      } catch (error) {
        if (requestId === this.certDetailRequestId) {
          this.certDetailError = true;
          this.$message.error("认证状态查询失败，请稍后重试");
        }
      }
    },
    refreshOnFocus() {
      const section = this.$refs.protocolSection;
      if (!this.certDetailLoaded || this.submitting
          || (section && (section.submitting || section.editingSignature || section.hasDrawn))) return;
      this.refreshCertificationStatus();
    },
    clearFormForOwnerChange() {
      this.form = this.$options.data.call(this).form;
      this.deptPath = [];
      this.approveState = "";
      this.latestApproveState = "";
      this.editMode = false;
      this.certDetailReady = false;
      this.certDetailError = true;
      this.certDetailLoaded = false;
      this.formOwner = null;
      this.formOwnerInvalidated = true;
      this.certDetailRequestId += 1;
      this.savedProtocolSignature = null;
      this.effectiveProtocolSignature = null;
      this.effectiveCertGuid = "";
      this.certDraft = false;
      this.changeDraft = false;
      this.baselineIdentity = null;
      this.identityChanged = false;
      const section = this.$refs.protocolSection;
      if (section && !section.signatureOwnerChanged) section.blockForChangedSignatureOwner();
      this.$message.error("当前人员或租户已变化，请重新进入认证页面");
    },
    ensureFormOwner() {
      if (this.formOwnerInvalidated) {
        this.$message.error("当前人员或租户已变化，请重新进入认证页面");
        return false;
      }
      if (!this.formOwner) {
        this.$message.error("无法确认当前人员和租户，填写内容已保留，请重新登录后重试");
        return false;
      }
      if (!sameDraftOwner(this.formOwner, currentDraftOwner())) {
        this.clearFormForOwnerChange();
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 0px;
  .cert-state-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 0;
    padding: 10px 16px;
    text-align: left;
    color: #426f73;
    background: #eef6f7;
    border: 1px solid #d8eaea;
    &.warn {
      color: #96754d;
      background: #fff8ed;
      border-color: #f1e5d0;
    }
    .cert-state-dot {
      width: 8px;
      height: 8px;
      flex: 0 0 8px;
      border-radius: 50%;
      background: currentColor;
    }
  }
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    margin-bottom: 4px;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: #212121;
    }
  }
  /* 可折叠卡片区块（questionnaireAdd 同款框架） */
  .base {
    background: #fff;
    border: 1px solid #d9d9d9;
    margin-bottom: 4px;
    text-align: left;
    .title {
      text-align: left;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid #ebeef5;
      background-color: #fafafa;
      cursor: pointer;
    }
    .title-config i {
      margin-right: 8px;
      color: #606266;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding: 8px 0;
      /* 26.3.3 表单控件宽度跟随列宽（用户 09-10 去掉固定 w300）：el-input 默认 100%，下拉/级联/日期须显式撑满 */
      /deep/ .el-select,
      /deep/ .el-cascader,
      /deep/ .el-date-editor {
        width: 100%;
      }
    }
    .el-col-12 {
      margin-bottom: 14px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .mt-4 {
    margin-top: 4px;
  }
  .mb-4 {
    margin-bottom: 4px;
  }
  .flow {
    background: #fff;
    padding-left: 20px;
  }
}
.identity-cards {
  display: flex;
  /* FOUR-2957①复测：1366×768 下 6 卡 120px+gap16(共800px) 超出内容区致"其他"折行，收紧至 108px+gap12(共708px) */
  gap: 12px;
  flex-wrap: wrap;
}
.identity-card {
  width: 108px;
  height: 56px;
  line-height: 56px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
}
.identity-card.active {
  border-color: #4fa1a4;
  color: #4fa1a4;
  background: #f0f7f6;
}
.inline-group {
  display: flex;
  gap: 8px;
  .w146 {
    width: 146px;
  }
}
.qual-cards {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.qual-card {
  width: 240px;
}
.qual-head {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.qual-name {
  margin-right: 8px;
  white-space: nowrap;
}
.qual-uploader /deep/ .el-upload--picture-card {
  width: 240px;
  height: 140px;
  line-height: 140px;
}
.qual-file-card {
  position: relative;
  width: 240px;
  height: 140px;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  overflow: hidden;
}
.qual-file-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f7fa;
}
.qual-file-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
  .qual-file-card:hover & {
    opacity: 1;
  }
}
.qual-action {
  margin: 0 8px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.qual-preview-img {
  display: block;
  width: 100%;
}
.protocol-box {
  text-align: left;
  .protocol-body {
    width: 90%;
    margin: 0 auto;
    padding-bottom: 15px;
  }
  .protocol-status {
    font-size: 14px;
    margin-bottom: 12px;
    i {
      margin-right: 4px;
    }
    &.ok {
      color: #67c23a;
    }
    &.warn {
      color: #e6a23c;
    }
  }
  .protocol-sign-img {
    height: 120px;
  }
}

/* FOUR-2954③：全局 .el-icon-circle-close 被写成白色致日期控件清空按钮不可见，页面局部恢复默认灰 */
.content /deep/ .el-date-editor .el-icon-circle-close {
  color: #c0c4cc;
}
/* FOUR-2957②：录入文字（所在科室/标注经验等）色值统一 212121；排除禁用态（只读/审批中）保灰显语义 */
.content /deep/ .el-input:not(.is-disabled) .el-input__inner,
.content /deep/ .el-textarea:not(.is-disabled) .el-textarea__inner {
  color: #212121;
}
/* FOUR-2957③复测：标注经验与卡片右缘像素级对齐——原 calc(100%+5.55%) 基于减去 label 后的内容宽，
   屏越宽偏差越大（1366 下差 8px）；改为整行突破 90% 盒（负 margin 左移 5.56% + 宽度补 11.12%，基准均为盒宽），
   textarea 撑满后右缘即卡片右内缘 */
.content /deep/ .exp-col {
  width:100%;
  min-width: 600px;
}
.content /deep/ .exp-col .el-textarea {
  width: 100%;
}
.content /deep/ .el-textarea .el-input__count {
  right: 10px;
}

</style>
